import { useEffect, useRef, useCallback } from 'react';

/**
 * Hook para manejar retroceso de historial en modales y evitar salir de la app
 * al presionar el botón de navegación del teléfono (atrás físico o gestos).
 */
export const useBackHandler = (active, onBack, name = 'modal') => {
    const isManualRef = useRef(false);

    useEffect(() => {
        if (!active) return;

        // Reiniciar la bandera manual cuando el modal pasa a estar activo
        isManualRef.current = false;

        const modalState = { modalName: name, timestamp: Date.now() };
        window.history.pushState(modalState, '');

        const handlePopState = (e) => {
            if (isManualRef.current) {
                isManualRef.current = false;
                return;
            }

            const currentState = e.state || {};
            if (currentState.modalName !== name) {
                onBack();
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [active, onBack, name]);

    const triggerManualBack = useCallback((...args) => {
        if (active) {
            isManualRef.current = true;
            window.history.back();
        }
        onBack(...args);
    }, [active, onBack]);

    return triggerManualBack;
};

export default useBackHandler;
